module.exports = __webpack_public_path__ + "static/media/reglamento_1.a8e3410c.png";